import * as React from 'react'
import { useSurveyStorageWarning } from '@/hooks/useSurveyStorageWarning'

/**
 * The phone could not keep the draft. Leaving the survey can lose the work
 * that has not reached the server. The survey itself keeps running.
 */
export function SurveyStorageBanner(): React.ReactElement | null {
  const failed = useSurveyStorageWarning()
  if (!failed) return null
  return (
    <p
      role="alert"
      className="border-b border-default bg-surface px-3 py-2 text-sm text-danger"
    >
      This phone could not keep the draft. Leaving can lose unsaved work.
    </p>
  )
}
